import { Modal } from "bootstrap";
import "data-confirm-modal";

import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import ActiveStorageUpload from "@excid3/uppy-activestorage-upload";
import Url from "@uppy/url";
import Compressor from "@uppy/compressor";
import ImageEditor from "@uppy/image-editor";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/image-editor/dist/style.css";
import "@uppy/url/dist/style.css";

let uppyInstances = document.querySelectorAll("[data-uppy]") || [];
let uppyDocInstances = document.querySelectorAll("[data-doc-uppy]") || [];

if (
  uppyInstances.length > 0 &&
  uppyInstances.length > uppyDocInstances.length
) {
  document
    .querySelectorAll("[data-uppy]")
    .forEach((element) => setupUppy(element));
}

function setupUppy(element) {
  let trigger = element.querySelector('[data-behavior="uppy-trigger"]');
  let form = element.closest("form");
  let direct_upload_url = document
    .querySelector("meta[name='direct-upload-url']")
    .getAttribute("content");
  let field_name = element.dataset.uppy;
  trigger.addEventListener("click", (event) => event.preventDefault());

  let uppy = new Uppy({
    autoProceed: false,
    allowMultipleUploads: false,
    logger: Uppy.debugLogger,
    restrictions: {
      maxFileSize: 5200000,
      maxNumberOfFiles: 1,
      minNumberOfFiles: 1,
      allowedFileTypes: ["image/*"],
    },
  });

  uppy.use(ActiveStorageUpload, {
    directUploadUrl: direct_upload_url,
  });

  uppy.use(Dashboard, {
    trigger: trigger,
    inline: false,
    closeAfterFinish: false,
  });

  // uppy.use(Url, {
  //   target: Dashboard,
  //   companionUrl: "https://companion.uppy.io/",
  //   locale: {},
  // });

  uppy.use(ImageEditor, {
    target: Dashboard,
    quality: 1,
    cropperOptions: {
      viewMode: 1,
      background: false,
      autoCropArea: 1,
      responsive: true,
      croppedCanvasOptions: {},
    },
    actions: {
      revert: true,
      rotate: true,
      granularRotate: true,
      flip: true,
      zoomIn: true,
      zoomOut: true,
      cropSquare: true,
      cropWidescreen: true,
      cropWidescreenVertical: true,
    },
  });

  uppy.use(Compressor, {
    quality: 0.6,
    limit: 10,
  });

  uppy.on("complete", (result) => {
    // Rails.ajax
    // or show a preview:

    console.log("successful files:", result.successful);
    console.log("failed files:", result.failed);

    element
      .querySelectorAll("[data-pending-upload]")
      .forEach((element) => element.parentNode.removeChild(element));

    result.successful.forEach((file) => {
      appendUploadedFile(element, file, field_name);
      console.log("done!");
      console.log(element);
      console.log(file);
      setPreview(element, file);
    });
    uppy.reset();
  });
}

function appendUploadedFile(element, file, field_name) {
  const hiddenField = document.createElement("input");

  hiddenField.setAttribute("type", "hidden");
  hiddenField.setAttribute("name", field_name);
  hiddenField.setAttribute("data-pending-upload", true);
  hiddenField.setAttribute("value", file.response.signed_id);

  element.appendChild(hiddenField);
}

function setPreview(element, file) {
  let preview = element.querySelector('[data-behavior="uppy-preview"]');
  if (preview) {
    let src = file.preview
      ? file.preview
      : "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSpj0DBTVsaja01_xWh37bcutvpd7rh7zEd528HD0d_l6A73osY";
    preview.src = src;
  }
}
